export const AWS = "https://fago.s3.ap-south-1.amazonaws.com/";
// export const AWS = "https://fago-development.s3.ap-south-1.amazonaws.com/";
// export const ENDPOINT = "http://192.168.29.46:5000";
// export const ENDPOINT = "https://fago.backb.in:6443/";
export const ENDPOINT = "https://fago.live:8443/";
